import { Alpine } from '../../core/alpine-core.js';
import { apiFetch } from '../api.js';

Alpine.data('venuesList', () => ({

    items: [],
    page: 1,
    totalPages: 1,
    total: 0,
    filters: { q: '', sortBy: 'name:asc', limit: 20 },
    deleteOpen: false,
    deleteBusy: false,
    toDelete: null,
    loading: true,
    refreshSpinning: false,
    placeholderLogo: '/assets/placeholder-venue.png',

    filtersOpen: false,
    firstLoad: true,

    scrollToTopAfterPageChange() {
        if (window.innerWidth >= 768) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },

    async init() {
        await this.reload();
        this.firstLoad = false;
    },

    async reload() {
        this.loading = true;
        try {
            const q = new URLSearchParams({
                q: this.filters.q || '',
                sortBy: this.filters.sortBy,
                page: String(this.page),
                limit: String(this.filters.limit),
            });
            const url = `/venues?${q.toString()}`.replace(/\/{2,}/g, '/');
            const res = await apiFetch(url);
            const data = await res.json();
            this.items = data.items || [];
            this.page = data.page || 1;
            this.totalPages = data.totalPages || 1;
            this.total = Number(data.total ?? data.totalResults ?? 0);
        } finally {
            this.loading = false;
            this.refreshSpinning = false;
        }
    },

    async manualRefresh() {
        this.refreshSpinning = true;
        await this.reload();
    },
    async go(p) {
        const next = Math.min(Math.max(1, p), this.totalPages || 1);
        if (next === this.page) return;
        this.page = next;
        await this.reload();
        this.scrollToTopAfterPageChange();
    },

     showPager() {
        return Number(this.totalPages || 0) > 1;
    },
    from() {
        if (!this.total) return 0;
        const limit = Number(this.filters?.limit ?? 20);
        return (this.page - 1) * limit + 1;
    },
    to() {
        if (!this.total) return 0;
        const limit = Number(this.filters?.limit ?? 20);
        const end = this.page * limit;
        return end > this.total ? this.total : end;
    },

    hasActiveFilters() {
        const f = this.filters || {};
        // defaults assume sortBy 'name:asc' and limit 20
        return !!(
            (f.q && f.q.trim()) ||
            (f.sortBy && f.sortBy !== 'name:asc') ||
            (Number(f.limit) !== 20)
        );
    },

    confirmDelete(v) { this.toDelete = v; this.deleteOpen = true; },
    async doDelete() {
        if (!this.toDelete || this.deleteBusy) return;
        this.deleteBusy = true;
        try {
            const res = await apiFetch(`/venues/${this.toDelete._id}`, { method: 'DELETE' });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data?.message || 'Delete failed');

            this.$store.toastr.success('Venue deleted');
            this.deleteOpen = false;
            this.toDelete = null;
            await this.reload();
        } catch (e) {
            this.$store.toastr.error(e.message || 'Delete failed');
            this.deleteOpen = false;
        } finally {
            this.deleteBusy = false;
        }
    },

}));
